export default "__VITE_PUBLIC_ASSET__2d52d102__"